import React, { useState } from "react";
import styles from "./PushNotifications.module.scss";
import DynamicCardRow from "../../../../components/AdminPortalComponents/DynamicCardRow/DynamicCardRow";
import DynamicButton from "../../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";
import DynamicTableFilters from "../../../../components/common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters";
import DynamicDatatable from "../../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import { pushNotificationsTableData } from "../../dummyData";
import StatusBadge from "../../../../components/common/AdminCommonComponents/StatusBadge/StatusBadge";
import ActionButton from "../../../../components/common/AdminCommonComponents/Buttons/ActionButton/ActionButton";
import { Button } from "reactstrap";
import PerformanceTrackingImg from "../../../../assets/images/AdminPortalImages/performanceTracking.png";
import PushNotificationsCreation from "../../../../components/AdminPortalComponents/MarketingPromotions/PushNotifications/PushNotificationsCreation/PushNotificationsCreation";
import NotificationPerformanceTracking from "../../../../components/AdminPortalComponents/MarketingPromotions/PushNotifications/NotificationPerformanceTracking/NotificationPerformanceTracking";

const pushNotificationsData = [
    { title: "Total Subscribers", value: 0 },
    { title: "Active Push Campaigns", value: 0 },
    { title: "Pending Notification", value: 0 },
    { title: "Recent Engagement", value: 0 },
].map((item) => ({
    ...item,
    title: item.title.toUpperCase(),
}));

const PushNotifications = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isTrackingOpen, setIsTrackingOpen] = useState(false);

    const options = [
        { label: "View details" },
        { label: "Edit" },
        { label: "Delete" },
        { label: "Change status" },
    ];

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Title",
            selector: (row) => row.title,
            center: "true",
            minWidth: "120px",
        },
        {
            name: "Type",
            selector: (row) => row.type,
            center: "true",
            minWidth: "120px",
        },
        {
            name: "Image/Video",
            cell: (row) => <img src={row.imgSrc} alt={row.title} />,
            center: "true",
        },
        {
            name: "Notification Count",
            selector: (row) => row.count,
            center: "true",
            minWidth: "180px",
        },
        {
            name: "Status",
            cell: (row) => <StatusBadge statusName={row.status} />,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Resend",
            cell: () => <DynamicButton theme="purple">Resend</DynamicButton>,
            center: "true",
            minWidth: "180px",
        },
        {
            name: "Actions",
            cell: () => <ActionButton options={options} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div className={styles.mainContainer}>
            <div className={styles.overviewWrapper}>
                <div className={styles.mainHeadingBtnWrapper}>
                    <h5 className={styles.mainHeading}>Push Notifications Overview</h5>
                    <Button color="link" onClick={() => setIsTrackingOpen(true)} className={styles.performanceBtn}>
                        Performance Tracking
                        <img
                            src={PerformanceTrackingImg}
                            alt="Performance Tracking Img"
                            className={styles.trackingImg}
                        />
                    </Button>
                </div>
                <div className={styles.cardRowWrapper}>
                    <DynamicCardRow cards={pushNotificationsData} />
                </div>
            </div>

            {!isOpen && !isTrackingOpen ? (
                <div className={styles.filterTableWrapper}>
                    <div className={styles.headingBtnWrapper}>
                        <h5 className={styles.sectionHeading}>Push Notifications</h5>
                        <DynamicButton theme="purple" onClick={() => setIsOpen(true)}>
                            Create New Campaign
                        </DynamicButton>
                    </div>
                    <DynamicTableFilters
                        componentName={"Push Notifications"}
                        onApply={handleApply}
                        onClear={handleClear}
                    />
                    <div className={styles.tableWrapper}>
                        <DynamicDatatable
                            data={pushNotificationsTableData}
                            columns={columns}
                            type="gray"
                            pagination
                            highlightOnHover
                            responsive
                        />
                    </div>
                </div>
            ) : (
                isTrackingOpen ? <NotificationPerformanceTracking setIsTrackingOpen={setIsTrackingOpen} /> : <PushNotificationsCreation setIsOpen={setIsOpen} />
            )}
        </div>
    );
};

export default PushNotifications;